import {useQuery} from 'react-query'
import {
  api,
  queryClient,
  useMutationQuery,
} from 'base'
import {showSuccessNotification} from 'common/helpers'
import {Pagination} from 'common/types'
import { PAGE_SIZE } from './constants'

interface ReconciliationBase {
  [propName:string]: any
}
interface Reconciliation extends ReconciliationBase {
  x: any
}

interface Match extends ReconciliationBase {
  statementId:string;
  transactionUuid?: string;
  date?: string;
  type?: string;
  notes?: string;
}

interface UseGetReconciliationParams {
  page: number
}

export const useGetReconciliations = ({
  page,
}: UseGetReconciliationParams) => {
  return useQuery<Pagination<Reconciliation>, any>(
    ['all-reconciliations', {page}],
    async ({signal}) => {
      const {data} = await api.get('/reconciliation', {
        signal,
        params: {
          page,
          paginate: true,
          perPage: PAGE_SIZE,
        },
      })
      // console.log('api data', data)
      return data
    },
    {keepPreviousData: true}
  )
}

export const useReconciliationMatch = () => {
  return useMutationQuery<Match, any, ReconciliationBase> (
    ['reconciliation-match'],
    async (values) => {
      // console.log('mutation values', values)
      const url = `/reconciliation/${values.statementId}/match`
      const payload = {
        transactionUuid: values.transactionUuid,
        date: values.date,
        type: values.type,
        notes: values.notes,
      }
      // alert( url + '\r\n\r\n' + JSON.stringify(payload) )
      // if (!!url) return {}

      const {data} = await api.post(url, payload)
      return data.data
    },
    {
      onSuccess(data) {
        queryClient.invalidateQueries('all-reconciliations')
        showSuccessNotification(
          `Reconciliation has been marked as match.`
        )
      },
    }
  )
}

export const useGetStatements = ({
  page,
}: UseGetReconciliationParams) => {
  return useQuery<Pagination<Reconciliation>, any>(
    ['all-xero-statements', {page}],
    async ({signal}) => {
      const {data} = await api.get('/reconciliation/xeroStatement', {
        signal,
        params: {
          page,
          paginate: true,
          perPage: PAGE_SIZE,
        },
      })
      // console.log('api data', data)
      return data
    },
    {keepPreviousData: true}
  )
}

export const useGetTransactions = ({
  page,
}: UseGetReconciliationParams) => {
  return useQuery<Pagination<Reconciliation>, any>(
    ['all-transactions', {page}],
    async ({signal}) => {
      const {data} = await api.get('/reconciliation/transaction', {
        signal,
        params: {
          page,
          paginate: true,
          perPage: PAGE_SIZE,
        },
      })
      // console.log('api data', data)
      return data
    },
    {keepPreviousData: true}
  )
}

export const useRemoveTransactions = () => {
  return useMutationQuery<any, any, ReconciliationBase> (
    ['transactions-remove'],
    async (values) => {
      // console.log('mutation values', values)
      const url = `/reconciliation/transaction/remove`
      const {data} = await api.post(url, values)
      return data.data
    },
    {
      onSuccess(data) {
        queryClient.invalidateQueries('all-transactions')
        showSuccessNotification(
          `Transactions have been removed.`
        )
      },
    }
  )
}

export const useXeroSync = () => {
  return useMutationQuery<any, any, any> (
    ['xero-sync'],
    async () => {
      const url = `/project/syncAll`
      const {data} = await api.post(url, {})
      // console.log(data)
      return data.data
    },
    {
      onSuccess() {
        // queryClient.invalidateQueries('all-transactions')
        showSuccessNotification(
          `Xero sync started!`
        )
      },
    }
  )
}
